import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { conectarEmuladorFirestoreSeConfigurado } from "./emuladorFirestore";
import { conectarEmuladorAuthSeConfigurado } from "./emuladorAuth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
// Só em desenvolvimento e só com VITE_FIRESTORE_EMULATOR_HOST (ver emuladorFirestore.js).
conectarEmuladorFirestoreSeConfigurado(db);
export const storage = getStorage(app);
export const auth = getAuth();
// Só em desenvolvimento e só com VITE_AUTH_EMULATOR_HOST (ver emuladorAuth.js).
conectarEmuladorAuthSeConfigurado(auth);
export const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
